import React from "react";

const normalize = (t) =>
  String(t)
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    // awaryjnie: ujednolicenie bez polskich znaków dla "odpowiedź"
    .replace("odpowiedź", "odpowiedz");

const isExactPrefix = (t, target) => {
  if (typeof t !== "string") return false;
  return normalize(t) === normalize(target);
};

// usuwamy dokładnie te sentencje (bez ruszania reszty treści!)
const PREFIXES_TO_REMOVE = [
  "Poprawna odpowiedź:",
  "Twoja odpowiedź:",
  "Twoja odpowiedź: (brak odpowiedzi)",
];

function shouldRemoveTextNode(text) {
  if (typeof text !== "string") return false;
  const nt = normalize(text);

  return PREFIXES_TO_REMOVE.some((p) => nt === normalize(p));
}

function stripNode(node) {
  if (node == null || typeof node === "boolean") return node;

  // tekst
  if (typeof node === "string") {
    return shouldRemoveTextNode(node) ? null : node;
  }

  // liczby itp.
  if (typeof node !== "object") return node;

  // tablice dzieci
  if (Array.isArray(node)) {
    const mapped = node
      .map(stripNode)
      .filter((x) => x != null && x !== "");
    return mapped;
  }

  // React element
  if (React.isValidElement(node)) {
    // usuń dokładnie: <span>Poprawna odpowiedź: </span>, <span>Twoja odpowiedź: </span>, itd.
    if (
      typeof node.type === "string" &&
      node.type.toLowerCase() === "span" &&
      (shouldRemoveTextNode(node.props?.children) ||
        // na wypadek gdyby children było np. ["Twoja odpowiedź:", " "]
        (Array.isArray(node.props?.children) &&
          node.props.children.every(
            (c) => c == null || c === "" || shouldRemoveTextNode(c)
          )))
    ) {
      return null;
    }

    const children = node.props?.children;
    if (!children) return node;

    const newChildren = stripNode(children);

    return React.cloneElement(node, node.props, newChildren);
  }

  return node;
}

// Zachowuję nazwę exportu, żeby nic nie zmieniać w importach
export function stripAnswerPrefix(rendered) {
  return stripNode(rendered);
}
